import {
  OnboardingStatus,
  OrchestrationInfo,
  EvsesCompatibility,
  AssetOnboardingUrl,
  CustomerAccessTransfer,
  EvseSelfOnboardingDetails,
  LeadSmartChargingLightTransfer,
  SmartChargingOnboarding,
} from "src/models/smartChargingClientsModels";
import { callApi, callLeadTransfer } from "./callApi";

interface OrchestrationInfoProps {
  xIsonCustomerToken: string;
}

export const orchestrationInfo = ({
  xIsonCustomerToken,
}: OrchestrationInfoProps): Promise<OrchestrationInfo> => {
  return callApi({
    path: `/api/v1/micro-frontends/smart-charging/orchestration-info`,
    xIsonCustomerToken,
  });
};

export const leadSmartChargingLightTransfer = ({
  transferId,
  salesPartnerUuid,
}: {
  transferId: string;
  salesPartnerUuid: string;
}): Promise<LeadSmartChargingLightTransfer> => {
  return callLeadTransfer({
    path: `/api/v1/lead/smart-charging-light/transfer/${salesPartnerUuid}?transfer_id=${transferId}`,
  });
};

export const evsesCompatibility = (
  xIsonCustomerToken: string,
): Promise<EvsesCompatibility[]> => {
  return callApi({
    xIsonCustomerToken,
    path: "/api/v1/micro-frontends/smart-charging/evses/compatibility",
  });
};

export interface TransferDetailProps {
  transferId: string;
  payload: {
    manufacturer: string;
    modelName: string;
    compatibilityStatus: string;
  };
}

export const transferDetailUpdate = ({
  payload,
  transferId,
}: TransferDetailProps): Promise<string> => {
  return callApi({
    payload,
    transferId,
    method: "PUT",
    path: `/api/v1/lead/smart-charging-light/transfer/detail`,
  });
};

export interface SmartChargingOnboardingProps {
  payload: {
    modelName: string;
    manufacturer: string;
    tosAccepted: boolean;
    compatibilityStatus: string;
  };
  xIsonCustomerToken: string;
}

export const smartChargingOnboarding = ({
  payload,
  xIsonCustomerToken,
}: SmartChargingOnboardingProps): Promise<SmartChargingOnboarding> => {
  return callApi({
    payload,
    xIsonCustomerToken,
    method: "POST",
    path: `/api/v1/micro-frontends/smart-charging/evses/onboarding`,
  });
};

interface CustomerAccessTransferProps {
  payload: {
    tid: string;
  };
}

export const customerAccessTransfer = ({
  payload,
}: CustomerAccessTransferProps): Promise<CustomerAccessTransfer> => {
  return callApi({
    payload,
    method: "POST",
    path: `/api/v1/micro-frontends/customer-access/transfer`,
  });
};

interface EvseSelfOnboardingDetailsProps {
  xIsonCustomerToken: string;
}

export const evseSelfOnboardingDetails = ({
  xIsonCustomerToken,
}: EvseSelfOnboardingDetailsProps): Promise<EvseSelfOnboardingDetails> => {
  return callApi({
    path: `/api/v1/micro-frontends/evse-self-onboarding/onboarding-details`,
    xIsonCustomerToken,
  });
};

interface AssetOnboardingUrlProps {
  xIsonCustomerToken: string;
}
export const assetOnboardingUrl = ({
  xIsonCustomerToken,
}: AssetOnboardingUrlProps): Promise<AssetOnboardingUrl> => {
  return callApi({
    path: `/api/v1/micro-frontends/asset-onboarding/onboarding-url`,
    xIsonCustomerToken,
    method: "POST",
  });
};

interface OnboardingStatusProps {
  uuid: string;
  xIsonCustomerToken: string;
}

export const onboardingStatus = ({
  uuid,
  xIsonCustomerToken,
}: OnboardingStatusProps): Promise<OnboardingStatus> => {
  return callApi({
    path: `/api/v1/micro-frontends/evse-self-onboarding/onboarding-status/${uuid}`,
    xIsonCustomerToken,
  });
};

interface AuthenticationCallbackProps {
  xIsonCustomerToken: string;
  searchParams: string;
}

export const authenticationCallback = ({
  xIsonCustomerToken,
  searchParams,
}: AuthenticationCallbackProps): Promise<{
  msgId: string;
  data: {
    manufacturer: string;
    model: string;
  };
}> => {
  return callApi({
    method: "POST",
    xIsonCustomerToken,
    path: `/api/v1/micro-frontends/asset-onboarding/onboarding-callback${searchParams}`,
  });
};
